export const text = '#3E3937';
export const hover = '#A68676';
export const Red = '#EA2227';
export const title = `"Ogg",Arial, Helvetica, freesans, serif `;
export const White = "#F1EFEA";
export const Transition = "cubic-bezier(0.4, 0, 0, 1)"
export const textMid = 'Gill Sans MT Pro';
